import './pages/css/App.css';
import About from './pages/About';
import Skill from './pages/Skill';
import Project from './pages/Projects';
import Footer from './pages/Footer';
import Background from './pages/background';
import Header from './pages/Header';
import Landingpage from './pages/LandingPage';

import { Route } from 'react-router-dom';
import { BrowserRouter } from 'react-router-dom';
import { Routes } from 'react-router-dom';


function App() {

  const about_style = {
    paddingTop: '80px',
    backgroundColor: 'white',
  };
  const project_style = {
    paddingTop: '80px',
    backgroundColor: 'white',
  };
  const skills_style = {
    paddingTop: '80px',
    backgroundColor: 'white',
  };

  return (
    <div className="App">
      <BrowserRouter>
        <Background />
        <Header />
        <Routes>
          <Route path="/" element={<Landingpage />} ></Route>
          <Route path="/about" element={
            <div style={about_style}>
              <About />
            </div>
          }></Route>
          <Route path="/skill" element={
            <div style={skills_style}>
              <Skill />
            </div>
          }></Route>
          <Route path="/project" element={
            <div style={project_style}>
              <Project />
            </div>
          }></Route>
        </Routes>
        <Footer />
      </BrowserRouter>

    </div>
  );
}

export default App;
